import React from 'react';

import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import entryPoint from './entrypoint';

export function StorageHardLimitModal() {
	return <ModalEntryPoint entryPoint={entryPoint} dialogConfig={DIALOG_CONFIG} />;
}
